<template>
	<div class="h-100">
		<el-input style="width: 50%; padding-right: 10px" :value="searchText" @input="value => onChange(value)" />
		<sf-button line :onClick="filterSqlId">{{ getMessage_('SWCC000008') }}</sf-button>
		<sf-card class="border-0 bg-transparent" style="height: 93%; padding-top: 10px">
			<sf-data-table ref="searchTable" :columns="columns" :rows="rows" rowSize="sm" :showHeader="false" @row-click="onClick">
			</sf-data-table>
		</sf-card>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/SQLEditor/store/helpers';

export default {
	data() {
		return {
			filteredRows: []
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		columns() {
			return [
				{
					label: 'sql',
					prop: 'sqlId'
				}
			];
		},
		rows() {
			return this.filteredRows;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onClick(row) {
			this.DEFAULT_ASSIGN({
				key: 'searchParams',
				value: row
			});
			this.$sf_toggleLoading(true);
			this.getSqlContent_(this.searchParams.sqlId)
				// .then(this.getSqlLog_(this.searchParams.sqlId))
				.then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		async filterSqlId() {
			// console.log('@@filter확인');
			await this.$sf_toggleLoading(true);
			this.filteredRows = await this.sqlIds.filter(sqlId => sqlId.sqlId.includes(this.searchText));
			await this.$sf_toggleLoading(false);
		},
		onChange(value) {
			this.DEFAULT_ASSIGN({
				key: 'searchText',
				value: value
			});
		}
	}
};
</script>

<style></style>
